<template>
  <form @submit.prevent="newProject">
    <div class="mb-3">
      <label for="projectName">Название</label>
      <input type="text" name="projectName" v-model="formData.name" class="form-control" id="projectName">
    </div>
    <button type="submit" class="btn btn-primary">Создать</button>
  </form>
</template>

<script setup>
import {ref} from "vue";

import {useProjectStore} from '@/store/projects'
import router from "@/router";
const projectStore = useProjectStore()

// create project
const formData = ref({
  name: "",
})

async function newProject() {
  const project = await projectStore.create(formData.value)
  await router.push({name: 'project', params: { id: project.id }})
}
</script>
